import { render, staticRenderFns } from "./logisticcompanies.vue?vue&type=template&id=4d0bb45d&"
import script from "./logisticcompanies.vue?vue&type=script&lang=js&"
export * from "./logisticcompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports